export default {
  contractActivity: {
    contractActivity: {
      title: ({ plural }) => plural(["Actividad", "Actividades"]),
      type: {
        professional: "Empresa",
        pedagogic: "Formación",
      },
      tabs: {
        description: "Descripción",
        document: "Anexos",
      },
      status: {
        complete: "Completa",
        to_complete: "Por completar",
      },
      context: "Contexto",
      description: "Tareas realizadas",
      difficulties_encountered: "Dificultades & soluciones",
      results_obtained: "Resultados obtenidos",
      analysis_and_learning: "Análisis & aprendizaje",
      tools: "Herramientas & tecnologías",
      skills: "Competencias relacionadas",
      autonomy_complexity: "Autonomía & complejidad",
      missions: "Misiones relacionadas",
      no_activities: "Ninguna actividad está definida en este contrato.",
      no_activities_filtered: "Ninguna actividad coincide con el filtro seleccionado.",
      relatedSkills: {
        launch_analysis: "Iniciar el análisis",
        relaunch_analysis: "Relanzar el análisis",
        badge_default: "Análisis IA de competencias",
        badge_with_date: ({ named }) => `Referencial ${named("code")} — Análisis realizado el ${named("date")}`,
        badge_no_date: ({ named }) => `Referencial ${named("code")}`,
        no_activity_id: "Guarda primero la actividad para acceder a las competencias.",
        no_analysis:
          "Haz clic en « Iniciar el análisis » para identificar las competencias movilizadas en esta actividad.",
        analysing: "Análisis en curso, por favor espere…",
        ai_analysis: "Análisis IA de correspondencia entre la actividad y el bloque de competencias",
        summary_title: "Análisis IA de correspondencia de la actividad con las competencias",
        validated: "Validado",
        to_validate: "Por validar",
        validate_all_proposals: "Validar la relación actividad/competencias",
        add_block_picker_title: "Añadir manualmente bloques de competencias",
        add_block_confirm: "Añadir los bloques seleccionados",
        selected_skills_count: ({ named }) =>
          `${named("count")} competencia${named("count") <= 1 ? "" : "s"} seleccionada${named("count") <= 1 ? "" : "s"}`,
        collapsed_selected_skills_heading: "Competencias seleccionadas",
        skill_status_selected: "Competencia seleccionada",
        skill_status_validated: "Competencia validada",
      },
      annexes: {
        count: ({ named }) => `${named("count")} anexo(s) adjunto(s) a esta actividad`,
        technical_documents: "Documentos técnicos",
        screenshots_photos: "Capturas de pantalla & fotos",
        empty: "Ningún anexo adjunto a esta actividad.",
      },
    },
  },
};
